import type { ReactNode } from 'react';

export const symbol_adb: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M200-521v-40q0-72 33-131t87-97l-75-75 36-36 84.5 84q25.85-12 55.17-18.5Q450-841 480-841t59.5 6.5Q569-828 595-816l84-84 36 36-75 75q54 38 87 97.24 33 59.24 33 130.93V-521H200Zm428.5-91.5Q640-624 640-641t-11.5-28.5Q617-681 600-681t-28.5 11.5Q560-658 560-641t11.5 28.5Q583-601 600-601t28.5-11.5Zm-240 0Q400-624 400-641t-11.5-28.5Q377-681 360-681t-28.5 11.5Q320-658 320-641t11.5 28.5Q343-601 360-601t28.5-11.5Zm-107 491Q200-203 200-320v-161h560v161q0 117-81.5 198.5T480-40q-117 0-198.5-81.5Z"
		/>
	</svg>
);
